import { CustomModal } from '../../Modal/CustomModal';

// ── BalanceUpdateModal ───────────────────────────────────────────────────────

export const BalanceUpdateModal = ({
    showDetailsModal,
    setShowDetailsModal,
    titleLines,
    ledgers,
    grandTotal,
    formatSalesValue,
}) => {
    return (
        <CustomModal
            show={showDetailsModal}
            onHide={() => setShowDetailsModal(false)}
            size="lg"
            centered
            scrollable
        >
            <CustomModal.Header closeButton onHide={() => setShowDetailsModal(false)}>
                <CustomModal.Title className="text-base">Trial Balance Details</CustomModal.Title>
            </CustomModal.Header>

            <CustomModal.Body>
                {titleLines.length > 0 && (
                    <div className="mb-3 text-center">
                        {titleLines.map((line, i) => (
                            <div
                                key={i}
                                className={
                                    i === 0
                                        ? "text-base font-semibold text-gray-800"
                                        : "text-sm text-gray-600"
                                }
                            >
                                {line}
                            </div>
                        ))}
                    </div>
                )}

                {/* Ledgers table (flat — the source sheet no longer has group headers) */}
                <div>
                    <div className="text-sm font-semibold text-gray-700 mb-1.5">Ledgers</div>
                    <div className="overflow-x-auto tiny-scrollbar">
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-50 border-b border-gray-200">
                                    <th className="text-left px-2 py-1.5 font-semibold">Ledger</th>
                                    <th className="text-right px-2 py-1.5 font-semibold">Debit</th>
                                    <th className="text-right px-2 py-1.5 font-semibold">Credit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ledgers.map((ledger) => (
                                    <tr key={ledger.id} className="border-b border-gray-100">
                                        <td className="px-2 py-1">{ledger.name}</td>
                                        <td className="px-2 py-1 text-right">
                                            {formatSalesValue(ledger.debit)}
                                        </td>
                                        <td className="px-2 py-1 text-right">
                                            {formatSalesValue(ledger.credit)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </CustomModal.Body>

            {grandTotal && (
                <CustomModal.Footer>
                    <div className="flex justify-end gap-6 text-sm font-semibold text-gray-800">
                        <span>Grand Total Debit: {formatSalesValue(grandTotal.debit)}</span>
                        <span>Grand Total Credit: {formatSalesValue(grandTotal.credit)}</span>
                    </div>
                </CustomModal.Footer>
            )}
        </CustomModal>
    );
};